import { useEffect, useState } from "react";
import { useSpring, animated } from "react-spring";
import "./Cursor.css";

const Cursor = ({ scaling }) => {
  const [cursor, setCursor] = useState({ x: 0, y: 0 });
  const [{ x, y }, set] = useSpring(() => ({ x: 0, y: 0 }));
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 700);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsLargeScreen(window.innerWidth > 700);
    };

    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  useEffect(() => {
    if (!isLargeScreen) return;

    const mousemove = (e) => {
      setCursor({ x: e.clientX, y: e.clientY });
      set({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener("mousemove", mousemove);

    return () => {
      window.removeEventListener("mousemove", mousemove);
    };
  }, [set, isLargeScreen]);

  if (!isLargeScreen) return null;

  return (
    <animated.div
      style={{
        position: "fixed",
        top: y.interpolate((y) => `${y}px`),
        left: x.interpolate((x) => `${x}px`),
        width: 44,
        height: 44,
        cursor: "none",
        borderRadius: "50%",
        backgroundColor: "rgb(249,115,22)",
        pointerEvents: "none",
        transform: "translate(-50%, -50%)", // Center the outer circle on the cursor
      }}
    >
      <div
        className="inner-dot"
        style={{
          width: 8, // Adjust the size of the inner dot as needed
          height: 8, // Adjust the size of the inner dot as needed
          backgroundColor: "white", // Color of the inner dot
          borderRadius: "50%",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)", // Center the inner dot within the outer circle
        }}
      ></div>
    </animated.div>
  );
};

export default Cursor;
